import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import BeforeAfter from "@/components/site/BeforeAfter";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import HomeBold from "@/pages/designs/HomeBold";
import HomeWerkstatt from "@/pages/designs/HomeWerkstatt";

// Design 1 — Editorial premium (current default)
function HomeEditorial({ siteInfo, gallery, beforeAfter, reviews }) {
  return (
    <div data-testid="home-editorial" className="bg-sand-100 text-stone-900 min-h-screen">
      <Navbar siteInfo={siteInfo} />
      <Hero siteInfo={siteInfo} />
      <About siteInfo={siteInfo} />
      <Services />
      <Gallery items={gallery} />
      <BeforeAfter items={beforeAfter} />
      <Reviews items={reviews} siteInfo={siteInfo} />
      <Contact siteInfo={siteInfo} />
      <Footer siteInfo={siteInfo} />
    </div>
  );
}

export default function HomePage() {
  const [siteInfo, setSiteInfo] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [beforeAfter, setBeforeAfter] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [services, setServices] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/site-info").then((r) => setSiteInfo(r.data)).catch(() => {}),
      api.get("/gallery").then((r) => setGallery(r.data)).catch(() => {}),
      api.get("/before-after").then((r) => setBeforeAfter(r.data)).catch(() => {}),
      api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {}),
      api.get("/services").then((r) => setServices(r.data)).catch(() => {}),
    ]);
  }, []);

  // Dynamic SEO meta updates from siteInfo
  useEffect(() => {
    if (!siteInfo) return;
    const title = `${siteInfo.company_name} · ${siteInfo.tagline}`;
    document.title = title;
    const setMeta = (sel, value) => {
      const el = document.querySelector(sel);
      if (el && value) el.setAttribute("content", value);
    };
    setMeta('meta[name="description"]', siteInfo.description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', siteInfo.description);
    setMeta('meta[property="og:site_name"]', siteInfo.company_name);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', siteInfo.description);
  }, [siteInfo]);

  if (!siteInfo) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sand-100">
        <div className="font-display text-3xl text-stone-900">Laden…</div>
      </div>
    );
  }

  const design = siteInfo.design || "classic";
  const props = { siteInfo, gallery, beforeAfter, reviews, services };

  if (design === "dark") return <HomeBold {...props} />;
  if (design === "studio") return <HomeWerkstatt {...props} />;
  return <HomeEditorial {...props} />;
}
